import {DATE_FORMAT} from 'admin/components/bet_form/utils/LineConsts';
import moment from 'moment';

export const SHORT_DATE = 'YYYY-MM-DD HH:mm';
export const DATE_WITHOUT_TIME = 'YYYY.MM.DD';

export const commonTimeFormat = (unixTime: number, typeFormat = DATE_FORMAT): string => moment.unix(unixTime).format(typeFormat);
